// cspell:words MANAGECOMPONENTVERSION
import { emptyArray, emptyNull } from '../../../shared/misc';

const resolvePath = (componentVersionList) => (path) => path.replace(/{{MANAGECOMPONENTVERSION:(.*)}}/, (_, key) => componentVersionList[key]);

const resolveVersion = (componentVersionList) => (module) => {
  const { imports } = module;

  if (!imports) return module;

  return {
    ...module,
    imports: imports.map((item) => ({
      ...item,
      path: resolvePath(componentVersionList)(item.path)
    }))
  };
};

export const resolveModuleImports = (moduleList = emptyArray) => (componentVersionList = emptyNull) => moduleList.map(resolveVersion(componentVersionList));
